import React from "react";
import styled from "styled-components";

const ProjectCardWrapper = styled.div`
  position: relative;
  width: 35%;
  min-width: 300px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
  border-radius: 5px;

  /* box-shadow: -1px 1px 10px #9e9b9b; */

  @media (max-width: 1000px) {
    width: 90%;
  }
`;

const ProjectImage = styled.figure`
  border-radius: 5px;
  cursor: default;
  img {
    width: 100%;
    border-radius: 5px;
    border: 1px solid #e4e1e1;
    opacity: 1;
    display: block;
    transition: 0.5s ease;
    backface-visibility: hidden;
  }
  figcaption {
    text-align: left;
    height: 80px;
    > div:nth-child(1) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 10px 0;
    }
  }
  h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 10px 0;
    ::after {
      content: "";
      width: 100%;
      height: 2px;
      background-color: red;
    }
  }
  h4 {
    font-weight: 400;
    font-size: 16px;
  }
`;

const Button = styled.button`
  padding: 10px 15px;
  width: 120px;
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.fontColor};
  font-size: 18px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.fontColor};
  margin: 7px;
  cursor: pointer;
  outline: none;
  :hover {
    background-color: ${(props) => props.theme.fontColor};
    color: ${(props) => props.theme.body};
  }
  > i {
    margin: 0 5px;
  }
`;

const Container = styled.div`
  position: relative;
`;

const Middle = styled.div`
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;

  ${Container}:hover & {
    opacity: 1;
  }
`;

const ReadMoreButton = styled.button`
  color: ${(props) => props.theme.fontColor};
  background-color: ${(props) => props.theme.body};
  border: 1px solid ${(props) => props.theme.fontColor};
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  transition: all 500ms ease;
  cursor: pointer;
  :hover {
    border: 1px solid ${(props) => props.theme.body};
    background-color: ${(props) => props.theme.fontColor};
    color: ${(props) => props.theme.body};
  }
`;

function ProjectCard({
  img,
  title,
  description,
  responsibilities,
  type,
  techStack,
  blogLink,
  repoLink,
  demoLink,
  setCurrentProject,
  setPanel,
  features,
}) {
  const onClickHandler = () => {
    setPanel(true);
    setCurrentProject({
      img,
      title,
      description,
      responsibilities,
      type,
      techStack,
      blogLink,
      repoLink,
      demoLink,
      setCurrentProject,
      setPanel,
      features,
    });
  };

  return (
    <ProjectCardWrapper>
      <ProjectImage>
        <Container>
          <img src={img} alt={title}></img>
          <Middle>
            <div>
              <a target="_blank" rel="noreferrer" href={repoLink}>
                <Button>
                  <i className="devicon-github-original"> Code</i>
                </Button>
              </a>
            </div>
            <div>
              <a target="_blank" rel="noreferrer" href={demoLink}>
                <Button>
                  <i className="far fa-eye">Demo</i>
                </Button>
              </a>
            </div>
          </Middle>
        </Container>
        <figcaption>
          <div>
            <h2>{title}</h2>
            <div onClick={onClickHandler}>
              <ReadMoreButton>Read More</ReadMoreButton>
            </div>
          </div>
          <div>
            <h4>{description}</h4>
          </div>
        </figcaption>
      </ProjectImage>
    </ProjectCardWrapper>
  );
}

export default ProjectCard;
